import React from 'react';
import { useTranslation } from 'react-i18next';

export default function VacationTextFields({ title, description, onChange, titleId = 'Libelle', descriptionId = 'Description', titleRequired = false }) {
  const { t } = useTranslation();
  return <div className="my-6 space-y-4">
    <div>
      <label htmlFor={titleId} className="mb-2 block font-semibold">{t('vacationContent.title')}</label>
      <input id={titleId} type="text" value={title ?? ''} onChange={onChange} required={titleRequired}
        className="w-full rounded-xl border border-slate-300 px-4 py-3" />
    </div>
    <div>
      <label htmlFor={descriptionId} className="mb-2 block font-semibold">{t('vacationContent.description')}</label>
      <textarea id={descriptionId} rows={5} value={description ?? ''} onChange={onChange}
        className="w-full rounded-xl border border-slate-300 px-4 py-3" />
    </div>
  </div>;
}
